import { render, staticRenderFns } from "./CreateOrEditAsset.vue?vue&type=template&id=8ee879fa"
import script from "./CreateOrEditAsset.vue?vue&type=script&lang=js"
export * from "./CreateOrEditAsset.vue?vue&type=script&lang=js"
import style0 from "./CreateOrEditAsset.vue?vue&type=style&index=0&id=8ee879fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports